// ClientUpdateModal.js
import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getClientById } from "../../data/getters";
import Loading from "../helpers/Loading";
import ErrorMessage from "../helpers/ErrorMessage";
import { useLanguage } from "../helpers/LanguageContext";

const ClientUpdateModal = ({ handleClose, clientId, onUpdate }) => {
  const dispatch = useDispatch();
  const { t } = useLanguage();
  const [isLoading, setLoading] = useState(true);
  const [clientData, setClientData] = useState(null);
  const [showError, setShowError] = useState(false);
  const [errorOnSubmit, setErrorOnSubmit] = useState(false);
  const [updatedClientData, setUpdatedClientData] = useState({
    name: "",
    telephone: "",
    address: ""
  });

  useEffect(() => {
    const timeout = setTimeout(() => setShowError(true), 10000);

    async function fetchClientData() {
      try {
        const data = await dispatch(getClientById(clientId + 0));
        setClientData(data);
        setUpdatedClientData({
          name: data.name,
          telephone: data.telephone,
          address: data.address
        });
        setLoading(false);
        clearTimeout(timeout);
      } catch (error) {
        console.error("Error fetching client data:", error);
        setLoading(false);
        setShowError(true);
      }
    }

    fetchClientData();
    return () => clearTimeout(timeout);
  }, [clientId, dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedClientData({ ...updatedClientData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const updatedClient = {
      ...clientData,
      name: updatedClientData.name,
      telephone: updatedClientData.telephone,
      address: updatedClientData.address
    };

    if (
      updatedClient.name === clientData.name &&
      updatedClient.telephone === clientData.telephone &&
      updatedClient.address === clientData.address
    ) {
      setErrorOnSubmit(true);
    } else {
      onUpdate(updatedClient);
      handleClose();
    }
  };

  if (!clientData) return null;

  return (
    <>
      {showError ? (
        <ErrorMessage message={t("clientUpdateLoadError")} />
      ) : isLoading ? (
        <Loading />
      ) : (
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formClientName">
            <Form.Label>{t("clientUpdateName")}</Form.Label>
            <Form.Control
              type="text"
              placeholder={t("clientUpdateNamePlaceholder")}
              name="name"
              value={updatedClientData.name || ""}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formClientTel">
            <Form.Label>{t("clientUpdateTel")}</Form.Label>
            <Form.Control
              type="tel"
              placeholder={t("clientUpdateTelPlaceholder")}
              name="telephone"
              value={updatedClientData.telephone || ""}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formClientAddress">
            <Form.Label>{t("clientUpdateAddress")}</Form.Label>
            <Form.Control
              type="text"
              placeholder={t("clientUpdateAddressPlaceholder")}
              name="address"
              value={updatedClientData.address || ""}
              onChange={handleChange}
            />
          </Form.Group>
          <Button variant="primary" type="submit" style={{ cursor: "pointer" }}>
            {t("clientUpdateSubmit")}
          </Button>
        </Form>
      )}
      {errorOnSubmit && <ErrorMessage message={t("clientUpdateNoChange")} />}
    </>
  );
};

export default ClientUpdateModal;
